const showSupportModal = () => window.zE.activate();

export default showSupportModal;
